import React from "react";
import EnhancedContentSection from "./../../../components/common/enhanced-content-section";
import TitleHeader from "./../../../components/common/title-header";
import PageTagging from "components/common/page-tagging/page-tagging";

const TravelTimes = () => {
  let pageTitle = "Travel Times - Data Collection";

  return (
    <>
      <TitleHeader title={pageTitle} />

      <EnhancedContentSection
        isBlocking={false}
        showPageTitle={false}
        pageTitle={pageTitle}
      >
        <PageTagging
          title="Mr Traffic Equipment Hire | Travel Time - Data Collection Melbourne"
          description="Mr Traffic Equipment Hire. Melbourne's leading supplier of Travel Time - Data Collection boards Hire"
        />
        <div className="mt-3 services-default">
          <img
            src="/images/travel-times-page.jpeg"
            alt="Travel time message boards"
            className="image shadow"
          />

          <div className="mt-3 text-area">
            <h5>Travel Time Data Displayed For All</h5>
            <p>
              Use our colour VMS boards to display travel time data for
              motorists. Our direct access to VicRoads data provides the most up
              to date travel time information.
            </p>

            <p className="mt-3">
              <h5>Meets all requirements of AS4191</h5>

              <ul className="mt-3">
                <li>Easy operation</li>
                <li>Fully remote control</li>
                <li>Anti theft and tamper protection</li>
                <li>Solar pwered / Battery operated</li>
                <li>VicRoads STREAMS compatible</li>
                <li>GPS tracking</li>
              </ul>
            </p>
          </div>
        </div>
      </EnhancedContentSection>
    </>
  );
};

export default TravelTimes;
